import axios from '@/utilities/axios-global'

export function GET_USER_NOTIFICATIONS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/notifications/userlist?startDate=${payload.startDate}&endDate=${payload.endDate}`).then(response => {
      context.commit('SET_USER_NOTIFICATIONS', response.data)
      resolve(response)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_ACKNOWLEDGE_NOTIFICATION(context, payload) {
  return new Promise((resolve, reject) => {
    resolve(true)
    let url = context.rootState.user.baseApiUrl + `/notifications/acknowledge/${payload.row.assigneeId}`
    axios.put(url).then((response) => {
      context.commit('UPDATE_USER_NOTIFICATIONS', payload)
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function PUT_DISMISSACTIVATE_NOTIFICATION(context, payload) {
  return new Promise((resolve, reject) => {
    resolve(true)
    let url = context.rootState.user.baseApiUrl + `/notifications/dismissactivate/${payload.row.assigneeId}/${payload.condition}`
    axios.put(url).then((response) => {
      context.commit('DISMISSACTIVATE_USER_NOTIFICATIONS', payload)
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export default {
  GET_USER_NOTIFICATIONS,
  PUT_ACKNOWLEDGE_NOTIFICATION,
  PUT_DISMISSACTIVATE_NOTIFICATION
}
